const TOKEN_KEY = "panel_orquestador_token";
const USER_KEY = "panel_orquestador_user";
const DEVICE_KEY = "panel_orquestador_device"; // token del dispositivo de confianza (se queda aunque cierres sesión)
const FLAGS_KEY = "panel_orquestador_login_flags"; // avisos de después de entrar (activar 2 pasos, cambiar contraseña…): duran la pestaña

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  try {
    sessionStorage.removeItem(FLAGS_KEY);
  } catch (e) {
    // sin almacenamiento de sesión: nada que limpiar
  }
};

export const getUser = () => {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};

export const setUser = (user) => localStorage.setItem(USER_KEY, JSON.stringify(user));

export const getDeviceToken = () => {
  try {
    return localStorage.getItem(DEVICE_KEY);
  } catch (e) {
    return null;
  }
};
export const setDeviceToken = (token) => {
  try {
    localStorage.setItem(DEVICE_KEY, token);
  } catch (e) {
    // sin almacenamiento: no se podrá recordar el dispositivo
  }
};
export const clearDeviceToken = () => {
  try {
    localStorage.removeItem(DEVICE_KEY);
  } catch (e) {
    // nada
  }
};

export const getLoginFlags = () => {
  try {
    return JSON.parse(sessionStorage.getItem(FLAGS_KEY) || "{}");
  } catch (e) {
    return {};
  }
};
export const setLoginFlags = (flags) => {
  try {
    sessionStorage.setItem(FLAGS_KEY, JSON.stringify(flags || {}));
  } catch (e) {
    // sin almacenamiento de sesión: el aviso no se mostrará
  }
};
